import { render } from "./DataPanel.vue?vue&type=template&id=efb59cca&scoped=true"
import script from "./DataPanel.vue?vue&type=script&lang=js"
export * from "./DataPanel.vue?vue&type=script&lang=js"

import "./DataPanel.vue?vue&type=style&index=0&id=efb59cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb59cca"]])

export default __exports__